module.exports = __webpack_public_path__ + "static/media/34.a1cb5c28.png";